import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58a7f00b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "badge badge-pill bg-primary custom-badge"
}

import { useEmployeeStore } from '@/stores/UserEmployee';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBadge',
  props: {
    userId: {}
  },
  setup(__props: any) {

const employeeStore = useEmployeeStore();
const props = __props;

const employeeFullName = computed(() => {
    const employee = employeeStore.getByIdforFullName(props.userId ?? -1);
    if (!employee) {
        return 'NA'; // Return 'NA' if no employee is found
    }

    // Determine the role prefix based on user properties
    let rolePrefix;
    if (employee.user.is_superuser) {
        rolePrefix = "AD"; // Admin
    } else if (employee.user.is_staff) {
        rolePrefix = "MA"; // Manager
    } else {
        rolePrefix = "EM"; // Employee
    }

    // Concatenate the role prefix with the user's full name
    const displayName = `${rolePrefix} - ${employee.user.full_name}`;
    return displayName;
});


return (_ctx: any,_cache: any) => {
  return (employeeFullName.value)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(employeeFullName.value), 1))
    : _createCommentVNode("", true)
}
}

})